














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';
import moment from 'moment';

@Component({
  components: {
    Popup,
  },
})
export default class MarkMeasuringStateQualityCheckedDialog extends Vue {
  @Prop({ required: true })
  dates!: any[];
  show: boolean = false;
  localDates: any[] = [...this.dates];
  selectedDates: moment.Moment[] = [];

  public open() {
    this.show = true;
  }

  public closed() {
    this.selectedDates = [];
    this.show = false;
  }

  public save() {
    this.$emit('save', this.selectedDates);
    this.closed();
  }

  public updateSelectedDates() {
    const oldestDate = this.selectedDates.reduce((latest: moment.Moment | null, current: moment.Moment | null) => {
      return latest?.isBefore(current) ? current : latest;
    }, this.selectedDates[0]);

    if (!oldestDate) {
      return;
    }

    const earlierDatesThanOldestDate = this.localDates.filter((d) => d.value.isBefore(oldestDate));

    this.selectedDates = [...this.selectedDates, ...earlierDatesThanOldestDate.map((d) => d.value)];
  }

  @Watch('dates', { immediate: true, deep: true })
  onDatesChanged(newValue: any[]) {
    this.localDates = [...newValue];
  }
}
